import { Component, Input } from "@angular/core";
import { TradableTransaction, Transaction } from "@models/transaction";
import { CustomModal } from "../../../core/components/base-modals";

@Component({
	selector: "transaction-wrapper-modal",
	templateUrl: "./transaction-wrapper-modal.component.html",
	standalone: false
})
export class TransactionWrapperModalComponent extends CustomModal {
	@Input()
	public transaction: typeof Transaction;

	@Input()
	public activity: string = "";

	@Input()
	public closeAllPopups: boolean = false;

	@Input()
	public showShareButton: boolean = false;

	// eslint-disable-next-line
	public constructor() {
		super();
	}

	public isTradableTx(): boolean {
		return this.transaction instanceof TradableTransaction;
	}

	public onCloseEmitted(closeAll: boolean = false): void {
		if (this.closeAllPopups || closeAll) {
			this.closeAll();
		} else {
			this.close();
		}
	}
}
